type TranslationStringsForLanguage = {
  languages_code?: Pick<Queries.DirectusData_languages, 'code'> | null
}

export default function getEnglishStrings<T extends TranslationStringsForLanguage | null>(
  strings?: readonly T[] | null,
): T {
  return strings?.find(s => s?.languages_code?.code === 'en-US') as T
}
